import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const fishermanBeggen: NarratorNPC = {
  id: 'fisherman-beggen',
  name: 'Fisherman',
  dialog: dialog,
};
